module.exports = __webpack_public_path__ + "media/img/archi-11-7cf78ddf.png";